import { render, staticRenderFns } from "./StatiPatrimonialiListTable.vue?vue&type=template&id=7d498fd0&"
import script from "./StatiPatrimonialiListTable.vue?vue&type=script&lang=js&"
export * from "./StatiPatrimonialiListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports